/** @deprecated */
export enum Gift {
    Bear = 'bear',
    Flower = 'flower',
    Champagne = 'champagne',
    CherryOld = 'cherry',
    Kiss = 'kiss',
    Ring = 'ring',
    Heart = 'heart',
    Lipstick = 'lipstick',
    Peach = 'peach',
    Eggplant = 'eggplant',
    InLove = 'inlove',
    Fire = 'fire',
    Cherry = 'cherry2',
    Hat = 'hat',
    Ghost = 'ghost',
    Pumpkin = 'pumpkin',
    Chocolate = 'chocolate',
    Roses = 'roses',
    Heels = 'heels',
    Purse = 'purse',
    Lingerie = 'lingerie',
    Smartphone = 'smartphone',
    Watch = 'watch',
    Maldives = 'maldives',
    Car = 'car',
    ChristmasHat = 'christmasHat',
    ChristmasHouse = 'christmasHouse',
    ChristmasHeart = 'christmasHeart',
    ChristmasBear = 'christmasBear',
    ChristmasLollipop = 'christmasLollipop',
    ChristmasHeels = 'christmasHeels',
    ChristmasTree = 'christmasTree',

    Surprise = 'surprise',
    ChampagneGold = 'champagneGold',
    Alps = 'alps',
    Tangerines = 'tangerines',
    Sparkler = 'sparkler',
    Snowman = 'snowman',
    Year2025 = 'year2025',

    LoveYou = 'loveYou',
    Balloons = 'balloons',
    ChocolateHeart = 'chocolateHeart',
    Perfume = 'perfume',
    Cupid = 'cupid',
    BearHeart = 'bearHeart',
    Dinner = 'dinner',
    Paris = 'paris',
    RingHeart = 'ringHeart',

    Sun = 'sun',
    Macarons = 'macarons',
    Brunch = 'brunch',
    March8 = 'march8',
    Tulips = 'tulips',
    PerfumeFlower = 'perfumeFlower',
    HeelsSandals = 'heelsSandals',
    BearHeartFlower = 'bearHeartFlower',
    Picnic = 'picnic',
    ChocolateHeartFlower = 'chocolateHeartFlower',

    Angel = 'angel',
    Basket = 'basket',
    Bouquet = 'bouquet',
    Bunny = 'bunny',
    Chocolate2 = 'chocolate2',
    Earrings = 'earrings',
    EasterCake = 'easterCake',
    Eggs = 'eggs',
    Muffins = 'muffins',
    Picnic2 = 'picnic2',
    Wine = 'wine',

    HairBow = 'hairBow',
    Letter = 'letter',
    Mirror = 'mirror',
    MagicWand = 'magicWand',
    MysticRose = 'mysticRose',
    FairyHeels = 'fairyHeels',
    BallGown = 'ballGown',
    Unicorn = 'unicorn',
    Carriage = 'carriage',
    Crown = 'crown',
    Castle = 'castle',
}

export enum GiftViewPlace {
    Rating = 'rating',
}
